import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export interface BookingPhotoRequirement {
  id: string;
  description: string;
  required: boolean;
  disabled?: boolean;
}

export const bookingPhotoRequirementsQueryAtom = createQueryAtomFactory(
  'trade.bookingPhotoRequirements',
  (params: { bookingId: string }) => ({
    bookings: {
      __args: {
        filter: { ids: [params.bookingId] },
      },
      entries: {
        id: true,
        photoRequirements: {
          id: true,
          description: true,
          required: true,
        },
      },
    },
  }),
  {
    select: (data) => data?.bookings?.entries?.[0]?.photoRequirements ?? [],
  },
);
